import { Box, Typography } from "@avenue-8/sidekick-ui";
import { KeyFeaturesSectionView } from "@cma/presentation-generation-logic";
import { KeyFeatureItem } from "./components/KeyFeatureItem";
import { useKeyFeaturesLogic } from "./useKeyFeaturesLogic";
import { KeyFeaturesGrid, KeyFeaturesWrapper } from "./KeyFeatures.styles";
import { PresentationSectionViewProps } from "../PresentationSectionProps";

type Props = PresentationSectionViewProps<KeyFeaturesSectionView>;

export const KeyFeaturesView = (props: Props) => {
  const { sectionView } = props;
  const { keyFeaturesOptions } = useKeyFeaturesLogic({ sectionView });

  return (
    <Box
      id={sectionView.id}
      py={3}
      mt={2}
      margin="auto"
      textAlign="center"
      maxWidth={"lg"}
    >
      <Typography variant="h5">{sectionView.title}</Typography>

      {/* DESCRIPTION IS TOO LONG */}
      {/* {!!description && (
        <Typography mt={2} maxWidth={540} mx={"auto"}>
          {description}
        </Typography>
      )} */}

      <KeyFeaturesWrapper>
        <KeyFeaturesGrid>
          {keyFeaturesOptions.map((feature) => {
            if (!feature.show) return null;
            return (
              <KeyFeatureItem
                key={feature.configName}
                configName={feature.configName}
                valueName={feature.valueName}
                title={feature.title}
                value={feature.value}
              />
            );
          })}
        </KeyFeaturesGrid>
      </KeyFeaturesWrapper>
    </Box>
  );
};
